import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'config/axiosConfig';

interface MakeInquiryRequest {
    fullname: string;
    phoneNumber: string;
    email: string;
    message: string;
    propertyId: number;
}

interface MakeInquiryResponse {
    success: boolean;
    message: string;
    inquiryId: number;
    propertyId: string;
}

const makeInquiry = async (data: MakeInquiryRequest): Promise<MakeInquiryResponse> => {
    const response = await axiosInstance.post('/properties/public/make-inquiry', data);
    return response.data;
};

export const useMakeInquiry = () => {
    return useMutation({
        mutationFn: makeInquiry,
    });
};
